import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAllPostsAdmin, deletePost } from '../../services/blogApi';
import { toast } from 'react-toastify';

export default function Dashboard() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchPosts = () => {
    getAllPostsAdmin()
      .then(res => setPosts(res.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchPosts(); }, []);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    try {
      await deletePost(id);
      toast.success('Post deleted');
      fetchPosts();
    } catch {
      toast.error('Failed to delete post');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F5F7FA' }}>
      {/* Topbar */}
      <div style={{
        background: '#0A2540', padding: '0 24px',
        height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 800, fontSize: '1.2rem', color: '#fff' }}>
          Dennis<span style={{ color: '#7C4DFF' }}>.</span>
          <span style={{ color: 'rgba(255,255,255,0.3)', fontWeight: 400, fontSize: '0.85rem', marginLeft: 12 }}>Admin</span>
        </div>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Link to="/" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem' }}>← View Site</Link>
          <button onClick={handleLogout} style={{
            background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.7)',
            border: '1px solid rgba(255,255,255,0.1)', padding: '6px 16px',
            borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit', fontSize: '0.85rem',
          }}>
            Logout
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 24px' }}>
        {/* Header row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
          <div>
            <h1 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '1.8rem', fontWeight: 800, color: '#0A2540' }}>
              Blog Posts
            </h1>
            <p style={{ color: '#718096', marginTop: 4 }}>{posts.length} total posts</p>
          </div>
          <Link to="/admin/blog/new" style={{
            background: '#7C4DFF', color: '#fff', padding: '12px 24px',
            borderRadius: 8, fontWeight: 700, fontSize: '0.95rem',
            display: 'inline-flex', alignItems: 'center', gap: 8,
          }}>
            <i className="fas fa-plus" /> New Post
          </Link>
        </div>

        {/* Posts table */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <i className="fas fa-spinner fa-spin" style={{ color: '#7C4DFF', fontSize: '2.5rem' }} />
          </div>
        ) : posts.length === 0 ? (
          <div style={{
            background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0',
            padding: '60px 24px', textAlign: 'center',
          }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>📝</div>
            <h3 style={{ color: '#0A2540', marginBottom: 8 }}>No posts yet</h3>
            <p style={{ color: '#718096', marginBottom: 20 }}>Create your first blog post to get started.</p>
            <Link to="/admin/blog/new" style={{
              background: '#7C4DFF', color: '#fff', padding: '10px 24px',
              borderRadius: 8, fontWeight: 700, fontSize: '0.9rem',
            }}>
              Create First Post
            </Link>
          </div>
        ) : (
          <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#F5F7FA', borderBottom: '1px solid #e2e8f0' }}>
                  {['Title', 'Category', 'Status', 'Published', 'Actions'].map(h => (
                    <th key={h} style={{
                      padding: '14px 20px', textAlign: 'left', color: '#718096',
                      fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.5px',
                    }}>
                      {h.toUpperCase()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {posts.map((post, i) => (
                  <tr key={post.id} style={{
                    borderBottom: i < posts.length - 1 ? '1px solid #f0f0f0' : 'none',
                  }}>
                    <td style={{ padding: '16px 20px' }}>
                      <div style={{ fontWeight: 600, color: '#0A2540', fontSize: '0.92rem' }}>{post.title}</div>
                      {post.excerpt && (
                        <div style={{ color: '#718096', fontSize: '0.78rem', marginTop: 3 }}>
                          {post.excerpt.substring(0, 60)}...
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '16px 20px' }}>
                      {post.category ? (
                        <span style={{
                          background: 'rgba(124,77,255,0.10)', color: '#7C4DFF',
                          fontSize: '0.75rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                        }}>
                          {post.category}
                        </span>
                      ) : <span style={{ color: '#cbd5e0' }}>—</span>}
                    </td>
                    <td style={{ padding: '16px 20px' }}>
                      <span style={{
                        background: post.published ? 'rgba(124,77,255,0.10)' : 'rgba(237,137,54,0.1)',
                        color: post.published ? '#7C4DFF' : '#dd6b20',
                        fontSize: '0.75rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20,
                      }}>
                        {post.published ? 'Published' : 'Draft'}
                      </span>
                    </td>
                    <td style={{ padding: '16px 20px', color: '#718096', fontSize: '0.85rem' }}>
                      {post.publishedAt ? new Date(post.publishedAt).toLocaleDateString('en-GB') : '—'}
                    </td>
                    <td style={{ padding: '16px 20px' }}>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <Link to={`/admin/blog/edit/${post.id}`} style={{
                          padding: '6px 14px', borderRadius: 6,
                          background: 'rgba(74,144,217,0.1)', color: '#4a90d9',
                          fontSize: '0.8rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4,
                        }}>
                          <i className="fas fa-edit" /> Edit
                        </Link>
                        <button onClick={() => handleDelete(post.id, post.title)} style={{
                          padding: '6px 14px', borderRadius: 6,
                          background: 'rgba(229,62,62,0.1)', color: '#e53e3e',
                          border: 'none', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
                          fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 4,
                        }}>
                          <i className="fas fa-trash" /> Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
